import { render, staticRenderFns } from "./Odb.vue?vue&type=template&id=b04bf040&"
import script from "./Odb.vue?vue&type=script&lang=js&"
export * from "./Odb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports